// NOTE: The year numbers should match the folder name in /imgs
export const board = {
    "2025-2026":[
        {
            name: "Sonya Cisse",
            title: "Co-President",
            desc: "Hi! My name is Sonya and I’ve been in Flow since my freshman year. It’s where I’ve made most of my close friends and it’s given me some incredible memories that I’ll have for a long time. When I’m not spinning POI, I’m running or sketching random objects. I love this club and I’m excited to see what we can do this year!",
            imgName: "sonya.png"
        },
        {
            name: "Emerie Ngai",
            title: "Co-President",
            desc: "Hiii! My name is Emerie and I'm a co-pres this year! I've been in Flow since I was a tiny freshman and it has been a huge part of my time at Stuyvesant. I'm super excited to give back to this community and allow new members to have the same amazing experience that I did! My main prop is stringing and outside of flow, I love to dance, bake, and crochet. I'm looking forward to an awesome year :)))",
            imgName: "emerie.jpg"
        },
        {
            name: "Kayla Wang",
            title: "Inventory Manager",
            desc: "hi flowers! My name is Kayla and I'm one of your inventory managers this year!! Ever since I joined Flow in my freshman year, I've loved my time learning new moves and props! Outside of Flow, I like to create and listen to music! Thank you to all the flowers that have made our community as welcoming and amazing as it has been! Flow really means a lot to us and I look forward to what we'll achieve in this next year!",
            imgName: "kayla.png"
        },
        {
            name: "Iree Zheng",
            title: "Inventory Manager",
            desc: "Hello! I’m Iree, one of your inventory managers this year. I joined Flow freshman year as a stringer and I’m looking forward to meeting new people!",
            imgName: "iree.png"
        },
        {
            name: "Annie Chen",
            title: "Designer",
            desc: "Hi guys! I'm Annie, and this is round 3 of designing for flow 😛 I'm super excited to share my art with this amazing community for one more year. If you see me in the halls I'm probably eating, sleeping, or dancing with the occasional lock in.. and I'm always down to yap about anything! :3",
            imgName: "annie(1).jpg"
        },
        {
            name: "Fiona Huang",
            title: "Designer",
            desc: "Hi! I’m Fiona and I’ll be one of your designers this year. I’m super excited to design merch for flow. In my free time I love eating, hiking, binging shows (this is why I am always procrastinating), and crocheting. I can’t wait to see what this year brings to flow!!",
            imgName: "fiona.jpg"
        },
        {
            name: "Adam Oh",
            title: "IT manager",
            desc: "HI!!! I am excited to be IT this year!! Hoping to work hard on this website this year!!! My biggest hobby right now is dancing and I'm about to tweak with the new cell phone ban :( Can't wait to see how the next year will go!!!!!",
            imgName: "adam(1).png"
        },
        {
            name: "Felicity Yu",
            title: "IT manager",
            desc: "Hi guys! My name is Felicity and I’m one of the IT/Editors for flow this year! Outside of flow, you might find me sewing my own clothes, editing a video, or just laying down passed out on the ninth floor 😪I can’t wait to create some cool new content for flow this year! Don’t be shy and share some ideas with me 😼",
            imgName: "felicity.jpg"
        }
    ],

    "2024-2025": [
        {
            name: "Sarah Lin", 
            title: "Co-President", 
            desc: "Hello! I'm Sarah, one of your co-pres this year and I'm super excited to help Flow continue to grow in the Stuy community and beyond. My main prop is Flip Flop and I'll never forget when I learned that the name was a combination of Flow and Hip Hop, or when I found out Flow spelled backward is wolf, which is our logo. I met a lot of cool people and friends here so I'm sure you will too! It's about to be my fourth and last year in Flow and I know it'll be a good one! Also, I love food 😋", 
            imgName: "sarah.jpg"
        },

        {
            name: "Alejandra Yau-Smith", 
            title: "Co-President", 
            desc: "Hi! I'm Alejandra, a co-pres this year! I've been in flow since freshman year and I've had a lot of fun spinning props and learning new tricks. I'm excited to meet our new members this year! I like museums and parks a lot too :))", 
            imgName: "alejandra_yau-smith.jpg"
        },

        {
            name: "Leo Ye",
            title: "Inventory Manager",
            desc: "Hi! I'm Leo and I'll be one of your inventory managers this year. I spend an unhealthy amount of time on Valorant. I'm mostly doing something random when I'm not busy losing my mind over the stuff I have to do. My sleep schedule is also pretty nonexistent so I'm probably awake if you need me.",
            imgName: "leo_ye.jpg"
        }, 

        {
            name: "Adam Oh",
            title: "Inventory Manager",
            desc: "Hi, I'm Adam and I'm glad to be inventory manager this year! I am a dancer, an avid anime watcher, and am a depressed silver in valorant. I am both a flip flopper and whipper and have some ideas for future shows. I hope that this community continues to grow!",
            imgName: "adam.jpg"
        }, 

        {
            name: "Emerie Ngai", 
            title: "Treasurer", 
            desc: "Hi guys! I'm Emerie and I am super excited to be your treasurer this year! I can't wait to ask for money and make Flow super rich. I love to listen to music, bake, and crochet! I also have a really small smiski obsession (my wallet is crying 😅)", 
            imgName: "emerie_ngai.jpg"
        }, 

        { 
            name: "Phoebe Lu", 
            title: "Designer", 
            desc: "Hey chat, I'm Phoebe, your other designer! This is my last year in flow and I'm hoping I actually learn Levi this time :') You can catch me yapping about things at the back of first :3c I'm looking forward to drawing creatures for y'all!", 
            imgName: "phoebe_lu.jpg", 
        }, 

        { 
            name: "Annie Chen", 
            title: "Designer", 
            desc: "Hi y'all!! I'm Annie and this is my second year designing for Flow. I'm so excited to have the opportunity to share my art with this amazing community again. I love to draw, watch horror movies, and listen to music in my freetime (although my earbuds break almost every month..) and I'm always down to yap about anything   : ) ", 
            imgName: "annie.jpg", 
        }, 
    ],

    "2023-2024": [
        {
            name: "Ankki Dong", 
            title: "Co-President", 
            desc: "Hi everyone! My name is Ankki and I'm so excited to be this years co-prez. When I'm not spinning lights you can catch me painting or watching dramas, or layouting The Spectator. You may also see me get boba after practice (the original is the superior flavor). I am also a certified onion hater.", 
            imgName: "annki_dong.jpg"
        },

        {
            name: "Freda Dong", 
            title: "Co-President", 
            desc: "Not gonna lie, I never thought I'd be one of the co-presidents of a semi-dance club, but here I am! Flow has been a place where I made many wonderful friends and memories, even when times are hard. Besides Flow, I like to write poetry and short stories, play video games, code a little, and geek out about the stars. I look forward to spending my last year at Stuy with y’all. Heyja! I’m Freda, and I’m honored to be one of your co-presidents this year!", 
            imgName: "freda.jpg"
        },

        {
            name: "Rachel Gao",
            title: "Inventory Manager",
            desc: "Hello! I'm Rachel and I joined Flow because I fell in love with it at first sight (cliche, I know)! It's become a place of relaxation and a community that I can always turn to in times of stress, in which we practice for shows, meet new people, and have the occasional banter. I love music of any genre and also play video games! I'm excited to have another year of Flow and tons of staff dropping, see you there!",
            imgName: "rachel.jpg"
        }, 

        {
            name: "Sarah Lin", 
            title: "Treasurer", 
            desc: "Hello! I joined Flow my freshman year and now I’m about to start my junior year. Time really does fly when you’re having fun. I’m unsure about a lot of things, but trust me there is something special about dancing and spinning lights in the dark. And did I mention all the cool people I got to meet?", 
            imgName: "sarah_lin.jpg"
        }, 

        { 
            name: "Tiffany Leong", 
            title: "Designer", 
            desc: "Hi everyone! I’m Tiffany and this will be my 3rd year with Flow! My main prop is Flip Flop, but I’ve dabbled in stringing, whipping, and silk fans. I love making Spotify playlists only to loop the same song for hours on end and going to cafes!  I’m super excited to have the opportunity to continue designing for Flow my senior year ❤", 
            imgName: "tiffany.jpg", 
        }, 

        { 
            name: "Annie Chen", 
            title: "Designer", 
            desc: "Hi yall!! I’m Annie and I’m so excited to have the opportunity to design for Flow this year! I remember being mesmerized by all the pretty lights, and I’m honestly so grateful I got to meet so many people and I can’t wait to meet even more this year. Flow has meant so much to me and I’m so glad I can be a part of its amazing community and give back to it with my art : )", 
            imgName: "annie_chen.jpg", 
        }, 

        {
            name: "Adam Oh", 
            title: "Leader In Training", 
            desc: "Hi, I'm Adam and I'm glad to be on the board this year! Flow has been special to me as I've felt really connected to the people within the club. I remember when I first saw SING! in 2020 when supporting my brother in Senior SING and watching flow for the first time, it seemed magical. Joining last year was the most fun I've had in a while. I'm glad I found this club and I'm really excited to be leader in training this year. I can't wait to see the future of Flow unfold.", 
            imgName: "adam_oh.jpg",
        },
    ], 

    "2022-2023": [
        {
            name: "Aiden Chao",
            title: "President",
            desc: "Here's a story I don't tell often - my first memory of flow is from watching SophFrosh SING 2018 in 7th grade, and while funny in hindsight, it convinced me to want to go to Stuy. The same people that I saw perform that night became my first StuySquad directors, and eventually, my close friends. I found confidence from being around the people I've met over the past three years and it sometimes feels weird to think that I'm now in the same position as they were back then. There's so much love and effort put into running this massive community and I hope I can pass that onto future flow generations as well. I'm so proud of everything we've done and if you're reading this bio and thinking of joining, I hope you do! We'll do our best to teach you.",
            imgName: "aiden_pic.jpg",
        },
        {
            name: 'Sarah Ibrahim',
            title: 'Vice President',
            desc: "It's about to be my fourth year in Flow and I still can't believe it. I joined Flow on a whim without any expectations but now I can't imagine my life without Flow. Flow became my home where I could express myself without judgment. In my time with Flow, I've sprained my ankles too many times to count and caused many injuries to people's knees (sorry y'all). I've gotten hit by glowsticks and gone crazy trying to make the perfect choreo. And I would do it all over again in a heartbeat, just maybe with less injuries this time.",
            imgName: 'sarah_ibrahim.jpg'
        },
        {
            name: "Freda Dong",
            title: "Vice President",
            desc: "I remember being drawn into Flow for the pretty lights and the promise of no dancing involved! Spoilers: I started dancing. Throughout my time in Flow, I got to know so many amazing people and made so many friends, laughing as we bond over dropped staffs and video games. It's been a blast, and I can't wait for more. Heyja! I'm Freda, and it's an honor to serve as one of your vice presidents this year!",
            imgName: "freda_dong.jpg"
           
        },
        {
            name: "Rachel Gao",
            title: "Inventory Manager",
            desc: "Hello! I'm Rachel and I joined Flow because I fell in love with it at first sight (cliche, I know)! It's become a place of relaxation and a community that I can always turn to in times of stress, in which we practice for shows, meet new people, and have the occasional banter. I love music of any genre and also play video games! I'm excited to have another year of Flow and tons of staff dropping, see you there!",
            imgName: "rachel_gao.jpg"
 
        },
        {
            name: 'Tyler Zhou',
            title: "Designer",
            desc: "Hello everyone! I'm Tyler, your Flow senior designer for this year. I've been eyeing this club ever since one of our upperclassmen performed during Camp Stuy my freshman year. I've seen videos of flow arts performance online since before then but I thought it was so cool that this school had a club like this so I just had to join. Fast forward three years and I have the pleasure of contributing my art and designs for this beloved club's use. I look forward to my last year together with StuyFlow <333",
            imgName: "tyler_zhou.png"
 
        },
        {
            name: "Tiffany Leong",
            title: 'Designer',
            desc: "Hiya! I'm Tiffany and I”m so excited to be able to design for flow this year <3  I'm a stringer and I'd say spinning lights is probably the coolest thing I do, even though I've gotten many bruises from wrapping and the number of hours I've spent learning choreography is a little embarrassing. I joined at first because you can mess up without anyone knowing it's you, but I've grown to love Flow for the community and so much more! I love listening to music and I literally need it to do any basic task. I'm also a sucker for anything animated and always down for museum trips!",
            imgName: "tiffany_leong.jpg"
        },
        {
            name: "Alejandra Yau-Smith",
            title: "Leader In Training",
            desc: "Hi my name is Alejandra, but don't worry about mispronouncing it, I'm very used to alternate ways of saying it. I joined Flow after pressure from my parents to join a club, thinking I had deceived them by joining a club that spins lights. A year later, I'm now down a rabbit hole known as StuyFlow. I'm very excited to spend another year hitting myself (and spinning) with glow sticks :)",
            imgName: "alejandra.jpg"
        }
    ],

    "2021-2022": [
        {
            name: "Aaron Hsu",
            title: "President",
            desc: `There's something special about spinning lights with friends. I never thought that I would join a dance club, much less lead a crew of dancers, yet here I am. StuyFlow has become a place where I can express myself through pretty lights and help others “find their flow.” Outside of Flow, I like to build keyboards, code, and rock climb. 🥦`,
            imgName: "aaron_hsu.jpg"
        },
        {
            name: "Johanna Lin",
            title: "Vice President",
            desc: "Aloha! I joined Flow because spinny lights are cool, but I stayed for all the nice people I met. After a massive headache over formations, I found that being a leader is worth all the stress. Now I'm here and I hope I can maintain the safe space that StuyFlow provided me. Other than throwing around a stick, I like sleeping, playing games, and hanging out. Did someone say boba?", 
            imgName: "johanna_lin.jpg"
        }, 
        {
            name: "Sarah Ibrahim",
            title: "Vice President",
            desc: "My passions are watching overly dramatic shows that make me emotional and dancing to spine-breaking Kpop choreos. I play various instruments but my coolest one is the bassoon. Being a part of Flow is a dream come true since I stopped performing on stage when I was younger due to personal issues. Flow became my outlet to express myself and my home. I love hanging out with people but be warned, my clumsiness makes me a walking safety hazard!", 
            imgName: "sarah_ibrahim.jpg"
        },
        {
            name: "Aiden Chao",
            title: "Treasurer/Inventory Manager",
            desc: "What does Flow mean to me? I remember being drawn to spinning lights as a socially anxious 14 year old as if it were magic. And against all the expectations I had for myself at the time, I started to find a sense of passion and security in Flow. In other words, it's insane how much we can accomplish in a welcoming envornment that allows us to drown out our old inhibitions. Lately, I've been learning to use that optimism to bond with new and old friends, and to continue to learn new skills (my current favorites being biking and speedcubing!). I'd like to be able to provide the same community I had for new members of StuyFlow.", 
            imgName: "aiden_chao.jpg"
        },
        {
            name: "Jennifer Sun",
            title: "Designer", 
            desc: "Hi I'm Jennifer! I joined Flow my freshman year because I heard there would be cookies, and stayed after I saw how cool SING! was. Outside of Flow, I like to draw, play Tetris with friends, and sleep a lot! (Challenge me in Tetris :sunglasses::sunglasses::sunglasses:) Drawing has always been something that made me happy, and I'm super excited to be able to share that with Flow.", 
            imgName: "jennifer_sun.jpg"
        },
        {
            name: "Tyler Zhou",
            title: "Designer", 
            desc: "Hello, I'm one of your designers this year :D I've been drawing since I was little, and I've been doing digital art since middle school. When I'm not drawing or doing flow, I'm usually playing some silly gacha game cuz I have no life and I need that listening comprehension practice for my Japanese class. Besides all that, I'm just like any other stuy student, just trying to not fail my classes.", 
            imgName: "tyler_zhou.jpg"
        },
        {
            name: "Freda Dong",
            title: "Leader In Training",
            desc: "Heyja! Sorry in advance if I bumped into you in the hallway because I was reading a book or trying to do some last minute studying. I want to be a writer or an astronomer when I grow up. I also have a strange talent for folding stars. Frappes are great. Phoenixes are amazing. Pokemon are the best. And I want to be a dolphin for a day.",
            imgName: "freda_dong.jpg"
        }
    ],
    "2020-2021": [
        {
            name: "Raymond Xu",
            title: "President",
            desc: "Aside from my STEM interests, I love fostering environments where people are able to vibe and grow happily as a community. I joined StuyFlow in my sophomore year, and I have to give a shoutout to all the previous leaders of StuyFlow for cultivating a club for me to grow in. Because of this club, I've thankfully fallen out of my middle school gaming life as flowing and spending quality time with old and new people have become my new forte. Oh, and did I forget to mention that I have the same birthday as Jenny?",
            imgName: "raymond_xu.jpg"
        },
        {
            name: "Chloe Liu",
            title: "Vice President ☜(ﾟヮﾟ☜)",
            desc: "Flow is super cool to me because I get to meet so many new people and connect with them through an awesome form of art/dance :DD. Other than Flow, I volunteer in parks and a vision-disability center and I love to boulder, a form of rock climbing without a harness. I also like cool emojis like these: (´▽`ʃ♡ƪ) (●'◡'●) ლ(╹◡╹ლ) (๑•̀ㅂ•́)و✧ and stickers on Messenger.",
            imgName: "chloe_liu.jpg"
        },
        {
            name: "Aaron Hsu",
            title: "Vice President",
            desc: `I never thought that I would join a dance club, much less lead or direct a crew of dancers, yet here I am. StuyFlow has become a place where I can express myself through light manipulation and help others “find their flow.” Outside of Flow, I like to build keyboards, code, and rock climb.`,
            imgName: "aaron_hsu.jpg"
        },
        {
            name: "Kelly Huang",
            title: "Treasurer",
            desc: "I am a very chill and happy person. I like to play games and hang out with friends. I'm always down to get food and I absolutely love Pusheen. I really like talking and meeting new people.",
            imgName: "kelly_huang.jpg"
        },
        {
            name: "Jenny Liu",
            title: "Secretary",
            desc: "Hi there! I'm StuyFlow's version of Diane from Bojack Horseman. You can most likely find me reading, trying to balance a volleyball on my head, or drinking tea (I'm fond of Earl Grey). I joined StuyFlow freshman year, and it's been real great since then. It's a humbling experience to be part of an overwhelmingly talented and supportive community. Raymond tried to steal my birthday, but we're such nice people that we decided to share.",
            imgName: "jenny_liu.jpg"
        },
        {
            name: "Kevin Shaw",
            title: "Inventory Manager",
            desc: "Constantly caffeinated.",
            imgName: "kevin_shaw.jpg"
        },
        {
            name: "Constance Chen",
            title: "Designer",
            desc: "I was initially draw to Flow because of how aesthetically pleasing it was and the amazing community surrounding it, and was not disappointed at all when I joined my sophomore year ❤ Other than Flow, I really like baking and drinking bubble tea (my current goal in quarantine is to bake a really pretty and tasty brown sugar milk tea cake hehe) I also like listening to music and meeting new people! Feel free to hit me up anytime to chat 🙂",
            imgName: "constance_chen.jpg"
        },
        {
            name: "Susu Tran",
            title: "Designer",
            desc: "I like skating around and longboard dancing and teaching my friends to skate too. I draw when I have the time or if I'm bored in class, and I think being a tattoo artist would be pretty cool.",
            imgName: "susu_tran.jpg"
        },
        {
            name: "Sarah Ibrahim",
            title: "Leader In Training",
            desc: "Hi I'm Sarah. My passions are collecting dad jokes and watching overly dramatic shows that make me emotional. I know a lot about astrological signs if you want a reading. I am a friendly and funny person so let's hang out soon!",
            imgName: "sarah_ibrahim.jpg"
        }
    ],
    "2019-2020": [
        {
            name: "Khandaker Ridwan",
            title: "President",
            desc: "Aloha Flowers! I love learning about different languages and cultures through traveling! I also love taking photos. During my freshman year, I learned about this amazing club called StuyFlow. I loved how unique it was so I decided to join. Through the art of poi spinning and various new styles like Whipping and Flow x HipHop, the 2020 cohort changed Flow for the years to come. I absolutely love leading and being with this beautiful community.",
            imgName: "khandaker_ridwan.jpg"
        },
        {
            name: "Heiley Tai",
            title: "Vice President",
            desc: "Contrary to popular belief, my favorite food is NOT vegetables. It's bread. Before I joined Flow, I spent most of my time eating bread. But after spending three years of my life hitting myself with glowsticks for shows, I think my favorite food is bread with eggs, avocado, and chipotle. In all seriousness though, I'm really grateful I had the chance to join Flow (and be your VP! Still dunno how that happened). I think it's really shaped my high school experience and I met so many amazing people along the way. I have lots of good memories of Stuy, and it's mainly because of this club 🙂 yippee!! Oh, and I also like learning about brains. Brains are pretty cool.",
            imgName: "heiley_tai.jpg"
        },
        {
          name: "Steve Wang",
          title: "Inventory Manager",
          desc: "Hello friends! Fun fact: During my first ever Flow show (Sophfrosh SING! 2018) I tangled my strings with a friend and tossed a glowstick into a crowd and I now use that incredibly embarassing experience as inspiration that no matter your beginnings you can most definitely find a way to succeed in your passion. Now that that's said and done, outside of Flow I love playing video games and journaling about them (I have my own Instagram blog)! I also love musical theatre, though I tragically do not have an ounce of talent.",
          imgName: "steve_wang.jpg"
        },
        {
          name: "Maggie Xu",
          title: "Social Media Manager",
          desc: "I like lights ✨👄✨",
          imgName: "maggie_xu.jpg"
        },
        {
            name: "Raymond Xu",
            title: "Leader In Training",
            desc: "Aside from my STEM interests, I love fostering environments where people are able to vibe and grow happily as a community. I joined StuyFlow in my sophomore year, and I have to give a shoutout to all the previous leaders of StuyFlow for cultivating a club for me to grow in. Because of this club, I've thankfully fallen out of my middle school gaming life as flowing and spending quality time with old and new people have become my new forte. Oh, and did I forget to mention that I like to eat and sleep?",
            imgName: "raymond_xu.jpg"
        },
        {
            name: "Aaron Hsu",
            title: "Leader In Training",
            desc: "Hello my name is Aaron. My favorite vegetable is corn. In my free time, I like to spin lights, write code, and play games. Sometimes, I wonder what it would feel like to be a potato.",
            imgName: "aaron_hsu.jpg"
        },
    ],
    "2018-2019": [
        {
            name: "Jason Lin",
            title: "President",
            desc: "I love spinning lights and fire! I also love Quantum Chicken Soup Grass Big Chungus!",
            imgName: "jason_lin.jpg"
        },
        {
            name: "Kayli Matsuyoshi",
            title: "Vice President",
            desc: "My greatest interest at the moment would be atmospheric sciences, and I hope to someday work towards healing the planet. Aside from Flow, I enjoy playing tennis or running. Expression comes in many forms and can help someone find their voice or identity. Flow has helped me find both.",
            imgName: "kayli_matsuyoshi.jpg"
        },
        {
            name: "Khandaker Ridwan",
            title: "Vice President",
            desc: "Aloha Flowers! I love learning about different languages and cultures through traveling! I also love taking photos. During my freshman year, I learned about this amazing club called StuyFlow. I loved how unique it was so I decided to join. Through the art of poi spinning and various new styles like Whipping and Flow x HipHop, the 2020 cohort changed Flow for the years to come. I absolutely love leading and being with this beautiful community.",
            imgName: "khandaker_ridwan.jpg"
        },
        {
            name: "Celeste Cheung",
            title: "Treasurer",
            desc: "My name is Celeste Cheung. I joined StuyFlow as a freshman in 2015. Thanks to mentorship from older members I became a confident performer in the flow arts. I also co-directed various annual performances and took on a leadership role as treasurer of our club. I learned valuable leadership and collaborative skills from these experiences. However, the lasting friendships that come from practicing and performing with other members is the best part of joining Stuy Flow.",
            imgName: "celeste_cheung.jpg"
        },
    ],
    "2017-2018": [
        {
            name: "Alan Zhou",
            title: "President",
            desc: "Hi all! I'm now at Columbia University studying history and political science. Flow was a place where I became close with and built a community of friends that made my high school experience so much better. In my free time, I like to binge Netflix shows and keep up with politics and the news.",
            imgName: "alan_zhou.jpg"
        },
        {
            name: "Carol Chin",
            title: "Vice President",
            desc: "Hi everyone! I was VP of flow my senior year and I'm currently a student at NYU studying nursing. Flow was my second home, but also my second family. The people that I've met through this club are the people that have shaped the person that I am today. Teaching the new members and learning from my peers encouraged me to seek a profession that would allow me to engage with people. I'm lucky to have been a member of this club and I love how much the community has grown since I joined in my freshman year. In my free time you'll usually see me ballroom dancing, watching kdramas, or playing Animal Crossing!",
            imgName: "carol_chin.jpg"
        },
        {
            name: "Tracy Chang",
            title: "Vice President",
            desc: "Hi! My name is Tracy and I'm a current Stuy alum. Since I was drawn in by the pretty lights and joined Stuy Flow in my freshman year, I had the opportunity to meet unique people and truly find a family in the Stuyvesant community. I was able to step out of my comfort zone by performing on stage and by producing a show that I could be proud of. Having now graduated, I'm so proud of what Stuy Flow has since accomplished and how it's grown. In college, I was able to start a similar Flow club with other Stuy alums, and we hope to be able to introduce others to this new art form. I'm currently a marine science major and visual arts minor, so I enjoy drawing and photography in my free time. I also play badminton and figure skate, depending on the season! 🙂",
            imgName: "tracy_chang.jpg"
        },
        {
            name: "Sonal Parab",
            title: "Treasurer",
            desc: "Hi, I'm Sonal and I was treasurer of StuyFlow during the 2017-2018 school year. I loved StuyFlow because I was able to make amazing friends who I still talk to today and I was able to overcome my fear of performing by performing in the dark. Some of my other hobbies include bowling, programming, and eating in different restaurants around NYC!",
            imgName: "sonal_parab.jpg"
        },
    ],
    "2016-2017": [
        {
            name: "Wilson Wong",
            title: "President",
            desc: "I'm a pretty chill guy who likes to play a bunch of games and watch anime, and we'll be good friends if we share hobbies. According to other people, I also seem to be a pretty good teacher. It's difficult to get me mad, but you don't want to see when I am.",
            imgName: "wilson_wong.jpg"
        },
        {
            name: "Alice Chai",
            title: "Vice President",
            desc: "Hey everyone! I graduated Stuy in 2017 and was the VP of StuyFlow in my senior year. I'll graduate Fordham University in 2021 and pursue a career in Human Resources. I enjoy watching anime, kdramas, cdramas, and listening to kpop and EDM in my spare time. I'm also a Highly Sensitive Person (HSP). Feel free to hit me up on Facebook with any questions! You never know where life will take you. Live without regrets!",
            imgName: "alice_chai.jpg"
        },
        {
            name: "Alan Zhou",
            title: "Vice President",
            desc: "Hi all! I'm now at Columbia University studying history and political science. Flow was a place where I became close with and built a community of friends that made my high school experience so much better. In my free time, I like to binge Netflix shows and keep up with politics and the news.",
            imgName: "alan_zhou.jpg"
        },
    ],
    "2015-2016": [
        {
            name: "Kevin Yan",
            title: "President",
            desc: "I became president of StuyFlow in my junior year, and I was amazed at how much the club expanded by the time I graduated. I could never have imagined reaching our current size, and I am very proud of the generations of Flow members who contributed to that growth. The most memorable performances for me during my years were StuySquad 2015 and Senior SING! 2016. My personal style of flow is mainly glowstringing, specializing in wrap combos and handles.",
            imgName: "kevin_yan.jpg"
        },
        {
            name: "Angela Lin",
            title: "Vice President",
            desc: "",
            imgName: "angela_lin.jpg"
        },
        {
            name: "Wilson Wong",
            title: "Vice President",
            desc: "I'm a pretty chill guy who likes to play a bunch of games and watch anime, and we'll be good friends if we share hobbies. According to other people, I also seem to be a pretty good teacher. It's difficult to get me mad, but you don't want to see when I am.",
            imgName: "wilson_wong.jpg"
        },
        {
            name: "Nicholas Yang",
            title: "Treasurer",
            desc: "Currently student on leave from NYU. Cloudflare intern for fall 2020. Interested in programming languages, movies and cooking.",
            imgName: "nicholas_yang.jpg"
        },
    ],
};
